import { render, staticRenderFns } from "./Ordc01CompleteComponent.vue?vue&type=template&id=bc00b392&scoped=true&"
import script from "./Ordc01CompleteComponent.vue?vue&type=script&lang=ts&"
export * from "./Ordc01CompleteComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc00b392",
  null
  
)

export default component.exports